var React = require('react');

function Close (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"x":"66.3008","y":"21.6387","width":"74.2055","height":"2.71484","transform":"rotate(150 66.3008 21.6387)","fill":"white","key":0}),React.createElement("rect",{"x":"2.03516","y":"19.2881","width":"74.2055","height":"2.71484","transform":"rotate(30 2.03516 19.2881)","fill":"white","key":1})]);
}

Close.defaultProps = {"width":"67","height":"78","viewBox":"0 0 67 78","fill":"none"};

module.exports = Close;

Close.default = Close;
